import React from "react";
import { useSelector } from "react-redux";

const CostumerInfo = () => {
  const { user } = useSelector((state) => state.auth);

  return (
    <div className="bg-white rounded-lg shadow-lg p-4">
      <h2 className="text-xl font-semibold text-gray-700">Customer</h2>
      <p className="text-gray-600">{user?.name}</p>
      <p className="text-gray-600">{user?.surname}</p>
      <p className="text-gray-600">{user?.email}</p>
    </div>
  );
};

export default CostumerInfo;
